import { assign, createMachine } from 'xstate';

import { Context, Events } from './types';
import {
  addPaymentProfile,
  deletePaymentProfile,
  setActivePaymentProfile,
} from './actions';
import { serializePaymentProfiles } from './serializers';

export const initialContext: Context = {
  vaultCurrencies: null,
  subscriptionCurrency: null,
  error: null,
  subscriptionPaymentProfileId: null,
  paymentProfiles: [],
};

const paymentProfiles = createMachine<Context, Events>(
  {
    predictableActionArguments: true,
    context: initialContext,
    initial: 'idle',
    states: {
      idle: {
        on: {
          INITIALIZE: {
            target: 'fetchingProfiles',
          },
        },
      },
      fetchingProfiles: {
        invoke: {
          id: 'paymentProfilesFetch',
          src: 'getPaymentProfiles',
          onDone: {
            target: 'ready',
            actions: assign((ctx, event) => ({
              paymentProfiles: serializePaymentProfiles(
                event.data.items,
                ctx.vaultCurrencies,
                ctx.subscriptionCurrency,
                ctx.subscriptionPaymentProfileId
              ),
            })),
          },
          onError: {
            target: 'error',
          },
        },
      },
      error: {
        on: {
          RETRY_FETCH: 'fetchingProfiles',
        },
      },
      ready: {
        on: {
          DELETE_PAYMENT_PROFILE: {
            actions: 'deletePaymentProfile',
          },
          ADD_PAYMENT_PROFILE: {
            actions: 'addPaymentProfile',
          },
          CHANGE_PAYMENT_PROFILE: {
            actions: 'setActivePaymentProfile',
          },
        },
      },
    },
  },
  {
    actions: {
      deletePaymentProfile,
      setActivePaymentProfile,
      addPaymentProfile,
    },
  }
);

export { paymentProfiles };
